import { FC } from "react";
import { useTrackContext } from "../../hooks/useTrackContext";
import { TGameOptions } from "../../types";

interface IProps {
  title: TGameOptions;
  imgSource: string;
}

const GameCard: FC<IProps> = ({ title, imgSource }) => {
  const {
    vrSelection: { selectedGame },
    dispatch,
  } = useTrackContext();

  const handleGameSelection = (title: TGameOptions) => {
    dispatch({
      type: "SET_GAME_CUSTOMIZATION_SELECTED_GAME",
      payload: {
        selectedTrack: "VIRTUAL_REALITY",
        selectedGame: title,
      },
    });
  };

  return (
    <div
      className="tw-w-[287px] tw-h-[165px] tw-overflow-hidden tw-border-[2px] tw-border-[#AD44FF] tw-rounded-lg hover:tw-cursor-pointer"
      onClick={() => handleGameSelection(title)}
      style={{
        backgroundImage: `url("https://hyperkarting-product-component.vercel.app/${imgSource}")`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        backgroundSize: "cover",
      }}
    >
      <div className={`tw-w-full tw-h-full tw-bg-[#9D62FE] ${selectedGame === title ? "tw-bg-opacity-75" : "tw-bg-opacity-0"}`}>
        <div className="tw-w-full tw-h-full tw-flex tw-justify-center tw-items-center tw-font-[20px] tw-font-extrabold tw-text-white">
          {title === "CyberClash" ? "Cyber Clash" : title === "Zombies" ? "Death Squad" : title}
        </div>
      </div>
    </div>
  );
};

export default GameCard;
